import { checkCookies } from "cookies-next";
import { ATOKEN, RTOKEN } from "lib/config/global";
import { APIRefreshTokenExternal } from "lib/worker/api/refresh_token";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

interface Props {
  access_token: string;
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const { access_token, refresh_token } = context.query;

  try {
    const responseToken = await APIRefreshTokenExternal({
      refresh_token: refresh_token as string,
    });

    console.log(responseToken);

    context.res.setHeader("set-cookie", [
      `${ATOKEN}=${responseToken.access_token}`,
      `${RTOKEN}=${responseToken.refresh_token}`,
      `CON=YRD`,
    ]);

    return {
      props: {
        access_token: access_token ?? "",
      },
    };
  } catch (error) {
    console.log(error);
    return {
      props: {
        access_token: "",
      },
    };
  }
};

export default function ByPassPaage(_props: Props) {
  const [isLoadingTrue, IsloadingFalse] = useState<boolean>(true);
  const router = useRouter();

  useEffect(() => {
    const load = () => {
      const canLogin = checkCookies(ATOKEN);
      IsloadingFalse(canLogin);
      if (canLogin) {
        router.push("/", {}, { shallow: false });
      }
    };
    load();
  }, []);

  return <div> {isLoadingTrue ? "loading .." : "ไม่สามารถเชื่อมต่อได้"}.</div>;
}
